module.exports = function() {
  return new Worker(__webpack_public_path__ + "32d9ca968f4d4692346e.worker.js");
};